const map = {
	"./default-logo.png": 58943,
	"./favicon.png": 60484,
	"./footer-logo.png": 30211,
	"./logo-1.svg": 49790,
	"./logo-2.svg": 87613,
	"./logo-3.svg": 33340,
	"./logo-header-mobile.svg": 54377,
	"./logo-header-tablet.svg": 57055,
	"./logo-header.svg": 10410,
	"./logo-mobile.svg": 27731,
	"./logo.svg": 17936,
	"./maskable-icon.png": 4238
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15333;